var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWalletArrowColored(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24.061,
    viewBox: "0 0 24 24.061",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .walletArrowColored1,.walletArrowColored2{fill:none;stroke:#8c8d99;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px}.walletArrowColored2{stroke:#1bc47d}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "empty-wallet-change",
    transform: "translate(-428 -252)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    className: "walletArrowColored1",
    d: "M0 5.49V3.76A3.768 3.768 0 0 1 3.76 0h11.48A3.768 3.768 0 0 1 19 3.76V5.2h-2.02a2.06 2.06 0 0 0-2.04 2.23A2.132 2.132 0 0 0 17.1 9.3H19v1.19a3.768 3.768 0 0 1-3.76 3.76H9.76",
    transform: "translate(430.5 259.75)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    className: "walletArrowColored1",
    d: "M0 10.364v-4.57a2.848 2.848 0 0 1 1.84-2.67l7.94-3A1.9 1.9 0 0 1 12.35 1.9v3.8",
    transform: "translate(430.5 254.046)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    className: "walletArrowColored2",
    d: "M5.129 1.02v2.06a1.027 1.027 0 0 1-1 1.02h-1.96a2.132 2.132 0 0 1-2.16-1.87A2.008 2.008 0 0 1 .609.6a1.993 1.993 0 0 1 1.44-.6h2.08a1.027 1.027 0 0 1 1 1.02z",
    transform: "translate(445.43 264.95)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    className: "walletArrowColored1",
    d: "M0 0h7",
    transform: "translate(435 264)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    "data-name": "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-5",
    "data-name": "Vector",
    className: "walletArrowColored2",
    d: "M0 0h5.34A1.161 1.161 0 0 1 6.5 1.16v1.28",
    transform: "translate(431 268.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-6",
    "data-name": "Vector",
    className: "walletArrowColored2",
    d: "M1.22 0 0 1.22l1.22 1.22",
    transform: "translate(431 267.28)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-7",
    "data-name": "Vector",
    className: "walletArrowColored2",
    d: "M6.5 2.44H1.16A1.161 1.161 0 0 1 0 1.28V0",
    transform: "translate(431 271.34)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-8",
    "data-name": "Vector",
    className: "walletArrowColored2",
    d: "m0 2.44 1.22-1.22L0 0",
    transform: "translate(436.281 272.56)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletArrowColored);
export default __webpack_public_path__ + "static/media/wallet-arrow-colored.b41af7f7f10d388f33102dc0620fa191.svg";
export { ForwardRef as ReactComponent };